import {Box} from '@mui/material';
import NotFound from '@wearesection/bandai-react-components/organisms/NotFound';
import React from 'react';
import {GetRouter} from '~/utils';
type IProps = {
  title?: string;
  description?: string;
};
const NotFoundOrganisms: React.FC<IProps> = ({title, description}) => {
  const data = {
    title: title || '',
    description: description || '',
    iconNotFound:
      'https://images.ctfassets.net/hnoi7ctzfs57/6ITH9fmyysAbuvwk6W0QKP/ee0b0c4f9d80a148c4464cd65d180509/No_searching_result.svg',
  };
  const {pathname} = GetRouter();
  const PADDING_COMPONENT: any = {
    '/news': {
      padding: {
        xs: '80px 0px 132px 0px',
        md: '125px 0px 132px 0px',
      },
    },
    '/games': {
      padding: {
        xs: '80px 0px 132px 0px',
        md: '180px 0px 132px 0px',
      },
    },
  };
  return (
    <Box sx={PADDING_COMPONENT[pathname] ?? PADDING_COMPONENT['games']}>
      <NotFound {...data} />
    </Box>
  );
};

export default NotFoundOrganisms;
